export enum RegistrationType {
  INITIAL = "INITIAL",
  RENEW = "RENEW",
  EXTENSION = "EXTENSION",
}
